import { validateOwnerData } from 'registration/actions/validate-owner-data.actions';
import { fetchOwnerValidationMethod } from 'registration/actions/fetch-owner-validation.actions';
import template from './personal-information.html';

const mapStateToThis = ({ session, registration, config }) => {
  const { locale } = session;
  const { ownerData, ownerValidationMethod, retailer } = registration;
  const { phoneMask, phoneLength, maxFirstNameLength, maxLastNameLength, maxEmailLength, registrationLockoutPeriodMinutes } = config;

  const ownerValidationMethods = ownerValidationMethod[locale] ? ownerValidationMethod[locale] : [];
  const hasOwnerValidationMethods = ownerValidationMethods && ownerValidationMethods.length !== 0;

  return {
    ownerValidationMethods,
    hasOwnerValidationMethods,
    retailer,
    ownerData,
    phoneMask,
    phoneLength,
    maxFirstNameLength,
    maxLastNameLength,
    maxEmailLength,
    registrationLockoutPeriodMinutes,
  };
};

const mapDispatchToThis = {
  fetchOwnerValidationMethod,
  validateOwnerData,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'Responsive')
class SelfRegistrationPersonalInformationController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    await this.fetchOwnerValidationMethod(null, this.retailer.outletTypeId);
    this.shouldValidateEmail = !!(
      !this.hasOwnerValidationMethods &&
      (this.retailer.canSelfRegisterChainHead || this.retailer.canSelfRegisterSuperChain)
    );
  }

  $onDestroy() {
    this.unsubscribe();
  }

  validateEmail(form) {
    if (this.shouldValidateEmail) {
      const { email } = form;

      if (email.$pristine) {
        return;
      }

      this.validateOwner(form);
    }
  }

  async validateOwner(form) {
    this.isLoading = true;
    await this.validateOwnerData(this.formModel);
    this.isLoading = false;

    form.email.$setValidity('blocked-email', !this.ownerData.blocked);
    form.email.$setValidity('email-invalid', this.ownerData.validPin);
  }
}

export default class SelfRegistrationPersonalInformationComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationPersonalInformationController;
    this.bindings = {
      form: '=',
      formModel: '=',
      showPii: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/personal-information/personal-information-component.js